import { Popup } from 'react-map-gl'
import styled from 'styled-components'
import { useMapState } from '../state/context'
import { useCallback, useEffect, useMemo, useRef } from 'react'
import {
	CommentsNum,
	FastCharge,
	RegularCharge,
	TeslaLogo,
	ZapIcon,
} from '../utility/icons'
import styles from '../utility/styles'
import Text from './shared/Text'

const StyledPopup = styled(Popup)`
	cursor: pointer;
	& > .mapboxgl-popup-tip {
		border-top-color: ${styles.colors.background};
	}
	& > .mapboxgl-popup-content {
		padding: 0;
		border-radius: 4px;
		overflow: hidden;
		background-color: ${styles.colors.background};
	}
`

const Wrapper = styled.div`
	display: flex;
	justify-content: space-between;
	width: 220px;
`

const LogoWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 12px 4px;
	background-color: ${styles.colors.chargingGreen};
`

const TextWrapper = styled.div`
	margin: auto;
	width: 168px;
`

const Row = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`

const InfoRow = styled.div`
	display: flex;
	align-items: center;
	margin-right: 8px;
`

/**
 *
 * @param {{activePin:string, onTooltipClick:(id,lon,lat)=>void}} props
 * @returns
 */
export default function MapPopup({ activePin, onTooltipClick }) {
	const [{ pins }] = useMapState()
	const ref = useRef()
	const info = useMemo(
		() => pins.find(pin => pin.id === activePin),
		[pins, activePin]
	)
	const onClick = useCallback(() => {
		if (!info) return
		if (typeof onTooltipClick === 'function')
			onTooltipClick(info.id, info.location?.lon, info.location?.lat)
	}, [info, onTooltipClick])

	useEffect(() => {
		const el = ref.current?.getElement()
		if (el) el.onclick = onClick
	}, [onClick])

	if (!info) return false

	console.log('MapPopup info', { info })

	return (
		<StyledPopup
			longitude={info.location?.lon}
			latitude={info.location?.lat}
			anchor='bottom'
			closeButton={false}
			closeOnClick={false}
			closeOnMove={false}
			offset={62}
			{...{ ref }}
		>
			<Wrapper>
				<LogoWrapper>
					<TeslaLogo />
				</LogoWrapper>
				<TextWrapper>
					<Text.Caption
						variant='bold'
						style={{
							textOverflow: 'ellipsis',
							whiteSpace: 'nowrap',
							overflow: 'hidden',
						}}
					>
						{info.name}
					</Text.Caption>
					<Row>
						<InfoRow>
							{info.power_kw > 150 ? (
								<FastCharge
									fill={styles.colors.white}
									style={{ height: '16px' }}
								/>
							) : (
								<RegularCharge
									fill={styles.colors.white}
									style={{ height: '16px' }}
								/>
							)}
							<Text.Tiny>{info.power_kw}kW</Text.Tiny>
						</InfoRow>
						<InfoRow>
							<CommentsNum
								style={{ height: '16px', marginRight: '4px' }}
							/>
							<Text.Tiny>
								{info.social_meta?.post_count ?? 0}
							</Text.Tiny>
						</InfoRow>
						<InfoRow>
							<ZapIcon
								style={{ height: '16px', marginRight: '4px' }}
							/>
							<Text.Tiny>
								{info.social_meta?.zap_count ?? 0}
							</Text.Tiny>
						</InfoRow>
					</Row>
				</TextWrapper>
			</Wrapper>
		</StyledPopup>
	)
}
